import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const mobileSections = [
  {
    title: 'Navigazione',
    links: [
      { label: 'Home', to: '/' },
      { label: 'Guida Acquisti', to: '/articoli/itaobuy-spreadsheet-guida-completa' },
      { label: 'Blog', to: '/articoli/itaobuy-spreadsheet-guida-completa' },
    ],
  },
  {
    title: 'Categorie Prodotti',
    links: categories.map((c) => ({
      label: c.name,
      href: c.url,
      external: true,
    })),
  },
  {
    title: 'Risorse',
    links: [
      { label: 'Sicurezza', to: '/articoli/itaobuy-spreadsheet-sicurezza' },
      { label: 'Confronto', to: '/articoli/itaobuy-spreadsheet-vs-alternative' },
      { label: 'Classifica 2026', to: '/articoli/migliore-itaobuy-spreadsheet' },
      { label: 'Per Principianti', to: '/articoli/itaobuy-spreadsheet-per-principianti' },
      { label: 'Strategie', to: '/articoli/itaobuy-spreadsheet-strategie-avanzate' },
      { label: 'Recensioni', to: '/articoli/itaobuy-spreadsheet-recensioni' },
      { label: 'Categorie', to: '/articoli/itaobuy-spreadsheet-categorie' },
      { label: 'Come Usare', to: '/articoli/come-usare-itaobuy-spreadsheet' },
    ],
  },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);

  const closeAll = () => {
    setDropdownOpen(false);
    setMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-18">
        <Link to="/" onClick={closeAll} className="flex flex-col leading-tight">
          <span className={`font-heading text-lg md:text-xl font-semibold tracking-wide ${scrolled ? 'text-foreground-900' : 'text-white'}`}>
            ITAOBUY
          </span>
          <span className={`font-heading text-xs md:text-sm tracking-[0.3em] uppercase -mt-0.5 ${scrolled ? 'text-foreground-600' : 'text-white/80'}`}>
            Spread
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}
          >
            Home
          </Link>

          <Link
            to="/articoli/itaobuy-spreadsheet-guida-completa"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}
          >
            Guida Acquisti
          </Link>

          <div
            className="relative"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <button
              className={`flex items-center gap-1 text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}
            >
              Categorie
              <i className={`ri-arrow-down-s-line transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {dropdownOpen && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 bg-background-50 rounded-xl py-3 min-w-[260px] border border-background-200/70 shadow-sm">
                <p className="px-5 pb-2 text-xs text-foreground-400 font-label uppercase tracking-wider">14 Categorie</p>
                {categories.map((cat) => (
                  <a
                    key={cat.seq}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-3 px-5 py-2 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-accent-400 flex-shrink-0"></span>
                    {cat.name}
                  </a>
                ))}
              </div>
            )}
          </div>

          <Link
            to="/articoli/itaobuy-spreadsheet-sicurezza"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}
          >
            Sicurezza
          </Link>

          <Link
            to="/articoli/itaobuy-spreadsheet-guida-completa"
            className={`text-sm font-medium transition-colors whitespace-nowrap ${scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-white/90 hover:text-white'}`}
          >
            Blog
          </Link>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className={`hidden md:inline-flex items-center gap-2 px-5 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              scrolled
                ? 'bg-primary-500 text-white hover:bg-primary-600'
                : 'bg-white/20 text-white border border-white/30 hover:bg-white/30 backdrop-blur-sm'
            }`}
          >
            Apri Itaobuy Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg ${scrolled ? 'text-foreground-700' : 'text-white'}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-16 z-40 bg-background-50 overflow-y-auto">
          <div className="px-6 py-6 flex flex-col gap-8 pb-24">
            {mobileSections.map((section) => (
              <div key={section.title}>
                <h3 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3 font-label">
                  {section.title}
                </h3>
                <div className="flex flex-col gap-1">
                  {section.links.map((link) =>
                    'external' in link && link.external ? (
                      <a
                        key={link.label}
                        href={link.href}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors"
                        onClick={closeAll}
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-accent-400 flex-shrink-0"></span>
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        key={link.label}
                        to={link.to}
                        className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors"
                        onClick={closeAll}
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-primary-400 flex-shrink-0"></span>
                        {link.label}
                      </Link>
                    )
                  )}
                </div>
              </div>
            ))}

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 px-5 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer mt-4"
              onClick={closeAll}
            >
              Apri Itaobuy Spreadsheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}